import commons from 'legacyfrontend/components/commons';
import React from 'react';
import { useSelector } from 'react-redux';

export function useAmenitiesIcons() {
  const amenitiesIcons = useSelector((state) => state.applicationState.amenitiesIcons);

  function getIcon(keyName) {
    return React.useMemo(() => amenitiesIcons[keyName] || amenitiesIcons.default, [keyName]);
  }

  return [getIcon];
}

export function usePriceValidator() {
  const appCurrencyCode = useSelector((store) => store.applicationState.currency.description);

  function priceValidator(currencyExchange, prices) {
    if (prices.moneda && prices.moneda.toLowerCase() === appCurrencyCode.toLowerCase()) {
      return prices;
    }

    return (
      currencyExchange.find(
        (priceInCurrency) => priceInCurrency.moneda.toLowerCase() === appCurrencyCode.toLowerCase()
      ) || prices
    );
  }

  function priceTotal(price, pax = 1, humanized = false, decimals = 2, perPax = true) {
    const totalPrice = price.precioNeto + price.impuestos + price.impuestoPais + price.iva;
    const finalPrice = perPax ? totalPrice / pax : totalPrice;
    return humanized ? commons.numberFixedToMoney(finalPrice, decimals) : finalPrice;
  }

  return [priceValidator, priceTotal];
}

export function usePriceFromDetails() {
  const packageDetails = useSelector((store) => store.packages.details.data);
  const paxQuantity = useSelector((store) => store.packages.details.paxQuantity);
  const [priceValidator, priceTotal] = usePriceValidator();

  function getPriceInformation() {
    return priceValidator(
      packageDetails.salidas[0].conversionPrecios,
      packageDetails.salidas[0].precios
    );
  }

  function getFinalPrice(humanized, decimals, perPax = true) {
    const priceValidated = getPriceInformation();
    return priceTotal(priceValidated, paxQuantity, humanized, decimals, perPax);
  }

  return [getPriceInformation, getFinalPrice];
}
